import { tToastContext } from './Toast.types';

export const initialState: tToastContext = {
  alerts: [],
  addAlert: () => {},
  deleteAlert: () => {},
};
